module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_info"
    }
  }, [_c('div', {
    staticClass: "tea_r"
  }, [_c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_basic'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.personalInformation))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_edu'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.educationCourses))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_prize'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.awardsExperiences))])])], 1), _vm._v(" "), _vm._l((_vm.customs), function(custom, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_hnav"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'teacher_custom',
          params: {
            custom: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "teah_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v(_vm._s(_vm.showName(custom)))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "teacher": _vm.info,
      "teacherpublications": _vm.teacherpublications,
      "customs": _vm.customs
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502740f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeacherInfo.vue
// module id = 1237
// module chunks = 4